import { graphql, useStaticQuery } from 'gatsby';

const GetCareers = (locale) => {
   
    const data = useStaticQuery(graphql`
      {
        posts: allStoryblokEntry(
            filter: {field_component: {eq: "career"}}
            sort: {fields: first_published_at, order: DESC}
        ) {
          edges {
            node {
              id
              uuid
              name
              full_slug
              content
            }
          }
        }
      }
    `)

    let filteredPosts = data.posts.edges

    filteredPosts = filteredPosts.map((p, i) => {
        const content = p.node.content
        const newContent = typeof content === 'string' ? JSON.parse(content) : content
        p.node.content = newContent
        return p.node
    })

    // If locale is set. Should be either en or de
    if (locale) {
        let fullLocale = locale+'/careers'
        filteredPosts = filteredPosts.filter(item => item.full_slug.includes(fullLocale))
    }

    return filteredPosts

}

export default GetCareers